import Moment from "moment";
import Vue from "vue";
import { uploadFile,getOssTokenExternal,getOssToken } from "@/services/common";

// 防抖函数
export function debounce(fn, delay) {
  let timeout = null;
  return function() {
    let context = this;
    let args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
}
//计算年龄
export function computAgeBack(data, type) {
  //计算年龄
  if (type === 'age') {
    if (data) {
      let birth = new Date(data);
      let now = new Date();
      let age = now.getFullYear() - birth.getFullYear();
      if (now.getMonth() < birth.getMonth() || (now.getMonth() === birth.getMonth() && now.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    }
  } else {
    //计算工作年限
    if (data) {
      let date1 = new Date(data);
      let date2 = new Date();
      const oneDay = 24 * 60 * 60 * 1000; // 每天的毫秒数
      const diffTime = Math.abs(date2 - date1);
      const diffYears = diffTime / (365 * oneDay);
      return parseFloat(diffYears.toFixed(2));
    }
  }
}

Vue.prototype.computAgeBack = computAgeBack

//处理空数据展示 结果为 -
export function getEmptyBack (val) {
  if (val == null || val == undefined || val == '') {
    return '-'
  } else {
    return val
  }
}
Vue.prototype.getEmptyBack = getEmptyBack
//处理空数据展示
export function getNullEmptyBack (val) {
  if (val == null || val == undefined || val == '') {
    return window.i18n.t('talent_desc13')
  } else {
    return val
  }
}
Vue.prototype.getNullEmptyBack = getNullEmptyBack

//处理老数据question_name数据为null的情况
export function getQuestionName (en,zh) {
  if (window.i18n.locale == 'en') {
    if (en) {
      return en
    } else {
      return zh
    }
  } else {
    return zh
  }
}
Vue.prototype.getQuestionName = getQuestionName


export function formatUTCDateToLocal(dateString) {
  // 将UTC时间字符串转换为Date对象
  const date = new Date(dateString);

  // 获取年份
  const year = date.getUTCFullYear();

  // 获取月份，注意月份从0开始，所以需要加1
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');

  // 获取日期，确保两位数字
  const day = date.getUTCDate().toString().padStart(2, '0');

  // 获取小时
  const hours = date.getUTCHours().toString().padStart(2, '0');

  // 获取分钟
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');

  // 获取秒
  const seconds = date.getUTCSeconds().toString().padStart(2, '0');

  // 拼接成最终格式
  return `${year}-${month}-${day} ${hours}-${minutes}-${seconds}`;
}
Vue.prototype.formatUTCDateToLocal = formatUTCDateToLocal

//匹配度描述
export function getMatchRateDescByJob(val) {
  const obj = {
    text: "",
    icon: null,
  };
  val = Number(val);
  if (val >= 90) {
    obj.text = window.i18n.t("apply_desc78");
  }
  if (val >= 80 && val < 90) {
    obj.text = window.i18n.t("apply_desc79");
  }
  if (val >= 70 && val < 80) {
    obj.text = window.i18n.t("apply_desc80");
  }
  if (val >= 60 && val < 70) {
    obj.text = window.i18n.t("apply_desc81");
  }
  if (val < 60) {
    obj.text = window.i18n.t("apply_desc82");
  }
  return obj;
}


export function getMedian(arr) {
  arr = arr.sort((a, b) => a - b);
  let median;
  if (arr.length % 2 === 0) {
    median = (arr[arr.length / 2] + arr[arr.length / 2 - 1]) / 2;
  } else {
    median = arr[(arr.length - 1) / 2];
  }
  return median;
}

//对字符串进行加密
function compileStr(code) {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return escape(c + "leapin");
}
//字符串进行解密
function uncompileStr(code) {
  if (!code) return code;
  code = unescape(code);
  code = code.substr(0, code.length - 6);
  var c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}
export function SetStorage(key, value) {
  localStorage.setItem(key, compileStr(JSON.stringify(value)));
}
//获取localStorage
export function GetStorage(key) {
  // console.log(key, uncompileStr(localStorage.getItem(key)));
  return JSON.parse(uncompileStr(localStorage.getItem(key)));
}
//删除localStorage
export function RemoveStorage(key) {
  localStorage.removeItem(key);
}

export function SetSessionStorage(key, value) {
  sessionStorage.setItem(key, compileStr(JSON.stringify(value)));
}
//获取sessionStorage
export function GetSessionStorage(key) {
  return JSON.parse(uncompileStr(sessionStorage.getItem(key)));
}
//删除sessionStorage
export function RemoveSessionStorage(key) {
  sessionStorage.removeItem(key);
}

export function CopyToClipboard(clipBoardContent) {
  return new Promise((resolve, reject) => {
    let textArea = document.createElement("textarea");
    textArea.style.position = "fixed";
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = "2em";
    textArea.style.height = "2em";
    textArea.style.padding = 0;
    textArea.style.border = "none";
    textArea.style.outline = "none";
    textArea.style.boxShadow = "none";
    textArea.style.background = "transparent";
    textArea.value = clipBoardContent;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
      resolve(true);
    } catch (err) {
      // this.$notification.open({
      //   type: 'warning',
      //   message: "浏览器不支持复制, 请手动选择复制！"
      // })
      console.log(err);
      reject(false);
    }
    document.body.removeChild(textArea);
  });
}
// 日期排序
export function dateSort(key, arr) {
  return arr.sort((a, b) => Moment(a[key]) - Moment(b[key]));
}

// 获取文件的base64信息
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

// ali-oss upload img
export async function aliUpload(file, media_params = "", fileName = "", headers = {}) {
  try {
    let ossConfig = await getOssToken({
      media_params
    });
    let fd = new FormData();
    Object.keys(headers).forEach(key => {
      fd.append(key, headers[key]);
    });
    fd.append("key", `${ossConfig.dir}${fileName === "" ? file.name : fileName}`);
    fd.append("x-oss-object-acl", "public-read");
    fd.append("policy", ossConfig.policy);
    fd.append("OSSAccessKeyId", ossConfig.OSSAccessKeyId);
    fd.append("signature", ossConfig.Signature);
    fd.append("success_action_status", 201);
    fd.append("file", file);
    return uploadFile(ossConfig.host, fd);
  } catch (e) {
    console.log(e);
    return Promise.reject(e);
  }
}

// ali-oss upload cv
export async function aliUploadCv(file, type = "", fileName = "", headers = {}) {
  try {
    let ossConfig = await getOssTokenExternal({
      type
    });
    let fd = new FormData();
    Object.keys(headers).forEach(key => {
      fd.append(key, headers[key]);
    });
    fd.append("key", `${ossConfig.dir}${fileName === "" ? file.name : fileName}`);
    fd.append("x-oss-object-acl", "public-read");
    fd.append("policy", ossConfig.policy);
    fd.append("OSSAccessKeyId", ossConfig.OSSAccessKeyId);
    fd.append("signature", ossConfig.Signature);
    fd.append("success_action_status", 201);
    fd.append("file", file, `${fileName === "" ? file.name : fileName}`);
    return uploadFile(ossConfig.host, fd);
  } catch (e) {
    return Promise.reject(e);
  }
}

// objDeepCopy
export function objDeepCopy(source) {
  var sourceCopy = source instanceof Array ? [] : {};
  for (var item in source) {
    sourceCopy[item] =
      typeof source[item] === "object"
        ? objDeepCopy(source[item])
        : source[item];
  }
  return sourceCopy;
}

// get url query
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

// export function downloadFile(url, fileName) {
//   saveAs(url, fileName);
// }

// 创建blob对象
function downloadBlob(url) {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (xhr.status === 200) {
        resolve(xhr.response);
      } else {
        reject(new Error(xhr.statusText || 'Download failed.'));
      }
    }
    xhr.onerror = function () {
      reject(new Error('Download failed.'));
    }
    xhr.send();
  })
}

// clone https://github.com/eligrey/FileSaver.js/blob/master/src/FileSaver.js
function click(node) {
  try {
    node.dispatchEvent(new MouseEvent('click'));
  } catch (e) {
    const evt = document.createEvent('MouseEvents');
    evt.initMouseEvent(
      'click',
      true,
      true,
      window,
      0,
      0,
      0,
      80,
      20,
      false,
      false,
      false,
      false,
      0,
      null
    );
    node.dispatchEvent(evt);
  }
}

export function downloadURL(url, name = "") {
  const link = document.createElement("a");
  link.download = name;
  link.href = url;
  if ("download" in document.createElement("a")) {
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    // 对不支持download进行兼容
    click(link, (link.target = '_blank'));
  }
}

export function downloadFile(url, fileName = "") {
  return downloadBlob(url, fileName)
    .then(resp => {
      if (resp.blob) {
        return resp.blob();
      } else {
        return new Blob([resp]);
      }
    })
    .then(blob => URL.createObjectURL(blob))
    .then(url => {
      downloadURL(url, fileName);
      URL.revokeObjectURL(url);
    })
    .catch(err => {
      throw new Error(err.message);
    })
}

/**判断数组中 某个key是否重复
 *param arr 判断的数组
 *param key 判断的key
 *return 重复返回false 不重复返回一个对象 对象格式{ arr[i][key]:arr[i] ...}
 */
export function isHasRepeatKeyValue(arr, key) {
  let obj = {};
  for (let i = 0; i < arr.length; i++) {
    if (obj[arr[i][key]]) {
      return true;
    } else {
      obj[arr[i][key]] = arr[i];
    }
  }
  return false;
}

export function removeDup(arr) {
  const result = [];
  const obj = {};
  for (let i of arr) {
    if (!obj[i]) {
      result.push(i);
      obj[i] = 1;
    }
  }
  return result;
}

export function getObjValsum(obj = {}) {
  let arr = Object.values(obj).filter(item => item !== null);
  if (arr.length !== 0) {
    return arr.reduce((prev, current) => { return prev + current })
  }
}

export function getArrSum(arr) {
  return arr.reduce((prev, current) => {
    return prev + current;
  })
}

export function getFileNameByUrl(url) {
  return url.substring(url.lastIndexOf('/') + 1);
}

export function getUuiD(randomLength) {
  return Number(Math.random().toString().substr(2, randomLength) + Date.now()).toString(36);
}

export function removeAllStorage() {
  RemoveSessionStorage("leapin_saas_redirect_path");
  RemoveSessionStorage("isShowContrast");
  RemoveSessionStorage("contras_screen_condition");
  RemoveSessionStorage("contrast_select_checked_data");
  RemoveSessionStorage("contraster_id_list");
  RemoveSessionStorage("leapin_position_current");
  RemoveSessionStorage("talent_inventory_employee_list");
  RemoveSessionStorage("contras_screen_condition");
  RemoveStorage("interview_address");
  RemoveStorage("contact_name");
  RemoveStorage("contact_phone");
  RemoveStorage("new_guide");
  RemoveStorage("lan");
  RemoveStorage("user_info");
  RemoveStorage("versionnum");
}

export function removeArrEmptyValue(arr) {
  return arr.filter(s => s && s.trim());
}

function base64Img2Blob(code) {
  var parts = code.split(";base64,");
  var contentType = parts[0].split(":")[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;
  var uInt8Array = new Uint8Array(rawLength);
  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
}

export function downloadFileByLink(fileName, content) {
  var aLink = document.createElement("a");
  var blob = base64Img2Blob(content);
  var evt = document.createEvent("MouseEvents");
  evt.initEvent("click", false, false);
  aLink.download = fileName;
  aLink.href = URL.createObjectURL(blob);
  aLink.dispatchEvent(evt);
}

export function getRandomStr() {
  return `${new Date().getTime()}${parseInt(Math.random() * 1000)}`;
}

export function getRandomString() {
  const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let result = "";
  for (let i = 8; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

export function getDimensionName(index) {
  let name = ''
  switch (index) {
    case 0:
      name = window.i18n.t('inventory_dimension_2') //能力
      break;
    case 1:
      name = window.i18n.t('inventory_dimension_3') //潜力
      break;
    case 2:
      name = window.i18n.t('inventory_desc165') //文化价值观
      break;
    case 3:
      name = window.i18n.t('inventory_desc166') //自定义维度
      break;
    case 4:
      name = window.i18n.t('inventory_dimension_1') //绩效
      break;
    default:
      name = ''
  }
  return name;
}
